import { LOGOUT_USER, LOGIN_USER, SET_ACTIVE_KEY } from "./actions";

export const reducer = (state, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, user: action.payload };
    case LOGOUT_USER:
      return { ...state, user: null };
    case SET_ACTIVE_KEY:
      return { ...state, activeKey: action.payload };
    default:
      return state;
  }
};
